document.addEventListener('DOMContentLoaded', function() {
  const initSwiper = () => {
    const swiperContainers = document.querySelectorAll('.reviews-grid.swiper:not(.swiper-initialized)');
    
    swiperContainers.forEach(container => {
      const options = {
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
          769: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          998: {
            slidesPerView: 3,
            spaceBetween: 40
          }
        },
        pagination: {
          el: container.querySelector('.reviews-slider-pagination'),
          clickable: true
        }
      };

      try {
        new Swiper(container, options);
      } catch (e) {
        console.error('Swiper initialization failed:', e);
      }
    });
  };

  if (typeof Swiper === 'undefined') {
    const script = document.querySelector('script[src*="swiper"]');
    if (script) {
      script.addEventListener('load', initSwiper);
    }
  } else {
    initSwiper();
  }

  // Support for Shopify Theme Editor
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('google-reviews-section') || event.target.querySelector('.google-reviews-section')) {
      initSwiper();
    }
  });
});
